<template>

  <v-form>
    <LookupReg v-if="state.appStage.updateRegCurrentProgress === 'lookup'"></LookupReg>
    <v-card class="" outlined v-if="state.appStage.updateRegCurrentProgress === 'shop'">
      <v-toolbar
          color="#488ba6"
          dark
          outlined
      >
        <v-toolbar-title>{{ state.member.meeting.meetingInfo.name }}</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <ExtraProducts ></ExtraProducts>
      </v-card-text>
    </v-card>
    <UpdateForm v-if="state.appStage.updateRegCurrentProgress === 'pay'" :form-total="formTotal"></UpdateForm>
    <v-card-actions v-if="state.appStage.updateRegCurrentProgress === 'shop'">
      <v-spacer></v-spacer>
      <v-btn color="#488ba6" @click="setupUpdateForm" style="color:white">Continue</v-btn>
    </v-card-actions>
  </v-form>

</template>

<script>

import {mapGetters} from 'vuex'
import LookupReg from "@/components/update-registration/LookupReg";
import ExtraProducts from "@/components/ExtraProducts";
import UpdateForm from "@/components/update-registration/UpdateForm";

export default {
  name: "Start",
  computed: {
    ...mapGetters({
      state: 'getState',
    }),
  },
  methods: {
    setupUpdateForm: function () {
      this.$store.commit('continueUpdateRegForm', 'pay')
    },
  },
  props: [
    'formTotal'
  ],
  components: {
    LookupReg,
    ExtraProducts,
    UpdateForm
  }
}
</script>

<style scoped>

</style>